import { Modal } from "antd";
const ModalCustom = ({ children, ...props }) => {
  const modalStyles = {
    header: {
      padding: "16px 24px",
      borderBottom: "1px solid #f0f0f0",
      margin: "0",
    },
    body: {
      padding: "24px",
    },
    footer: {
      borderTop: "1px solid #f0f0f0",
      padding: "12px 24px",
      margin: "0",
    },
    content: { padding: "0 0" },
  };
  return (
    <Modal styles={modalStyles} {...props}>
      {children}
    </Modal>
  );
};

export default ModalCustom;
